import styled, { css } from "styled-components";

export const StyledAbsPosShellImageEditor = styled.div`
position: absolute;
  ${({rendererStretch}) => rendererStretch === 'fullHeight' 
    ? css`
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
    ` 
    : css`
      width: 100%;
      top: 50%;
      transform: translateY(-50%);
    ` 
  };
`